module.exports = __webpack_public_path__ + "static/media/painManagementImage2@2x.1ee55b1e.png";